import { h } from 'preact';
import { OnlineDot } from '../OnlineDot';
import { T } from '../../../styles/tokens';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'OnlineDot',
  category: '💬 Chat',
  description: 'Indicador de status online/offline (dot colorido)',
  usedIn: ['Chat', 'ChatHubPage', 'AgentesPage'],
  example: () => (
    <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: T.text, fontSize: 13 }}>
        <OnlineDot online={true} /> Online
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: T.text, fontSize: 13 }}>
        <OnlineDot online={false} /> Offline
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: T.text, fontSize: 13 }}>
        <OnlineDot online={true} size={12} /> Grande
      </div>
    </div>
  ),
};
